"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _isEqual2 = _interopRequireDefault(require("lodash/isEqual"));

var _uniqWith2 = _interopRequireDefault(require("lodash/uniqWith"));

var _isString2 = _interopRequireDefault(require("lodash/isString"));

var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));

var _get2 = _interopRequireDefault(require("lodash/get"));

var _map2 = _interopRequireDefault(require("lodash/map"));

var _isMatch2 = _interopRequireDefault(require("lodash/isMatch"));

var _react = _interopRequireDefault(require("react"));

var _core = require("@emotion/core");

var noRecommendationFound = 'No recommendations for the given fulfillment location';
var postalCodeError = {
  message: 'No recommendations could be found based on the supplied criteria.',
  responseBody: {
    title: 'Unprocessable request',
    type: 'https://planning.logistics.cimpress.io/errors/unprocessable-entity',
    causes: [{
      type: 'https://shipping-options.logistics.cimpress.io/errors/invalid-postal-code',
      detail: "Invalid address or address given: The input postal code doesn't match any format"
    }]
  }
};
var infeasibleAddress = {
  message: 'Infeasible address. None of the available carrier services can ship to given destination'
};

var mapError = function mapError(error) {
  if (error === noRecommendationFound) {
    return {
      title: 'No recommendations could be found.',
      message: (0, _core.jsx)("div", null, "Please contact ", (0, _core.jsx)("a", {
        href: "mailto: logisticssupport@cimpress.com"
      }, "logisticssupport@cimpress.com"), " with the planning request.")
    };
  }

  if ((0, _isMatch2["default"])(error, postalCodeError)) {
    return {
      title: 'No recommendations could be found due to an invalid postal code.',
      message: 'The postal code did not match any format. Please check that it is a valid postal code.'
    };
  }

  if ((0, _isMatch2["default"])(error, infeasibleAddress)) {
    var alertContent = {
      title: 'The address is infeasible. None of the available carrier services can ship to the given destination.'
    };
    var carriers = (0, _map2["default"])((0, _get2["default"])(error, 'problems', []), function (problem) {
      return problem.carrierService;
    }).join(', ');

    if ((0, _isEmpty2["default"])(carriers)) {
      return alertContent;
    }

    alertContent.message = "Carrier Services: ".concat(carriers);
    return alertContent;
  }

  if ((0, _isString2["default"])(error)) {
    return {
      title: error
    };
  }

  var title = (0, _get2["default"])(error, 'message');
  var message = (0, _get2["default"])(error, 'responseBody.causes[0].detail');

  if ((0, _isString2["default"])(title)) {
    return {
      title: title,
      message: message
    };
  }

  return {
    title: 'Shipment Plan Failed',
    message: 'Please check the errors below.'
  };
};

var filterErrors = function filterErrors(errors) {
  var uniqueErrors = (0, _uniqWith2["default"])(errors, _isEqual2["default"]);
  return (0, _map2["default"])(uniqueErrors, function (error) {
    return mapError(error.errorMessage);
  });
};

var _default = filterErrors;
exports["default"] = _default;